module.exports = __webpack_public_path__ + "img/1478366349.2d99d93a.jpg";